import gql from "graphql-tag";
// IMPORTANT: keep this query in its own file for optimal code chunking.
export const UpsellPriceRangeDisplay = gql`
  fragment UpsellPriceRangeDisplay on UpsellProductPriceRangeDisplay {
    __typename
    __typename
    isUnavailable
    showMemberPrice
    skulowestMemberPrice
    nextGenDriven
    nextGenDrivenOnSale
    listPrices
    salePrices
    memberPrices
    salePrices
    currencySymbol
    overridePriceLabel
  }
`;
